import SVG from './SVG'
import * as T from './types'

const ConversationBubbleDouble = (props: T.ISVGProps) => (
  <SVG
    {...props}
    viewBox="0 0 22 21"
    fillRule="evenodd"
    clipRule="evenodd"
    d="M18.0164 9.98573C18.0164 12.1917 16.2239 13.98 14.0127 13.98H5.00455C4.20238 13.9648 3.42744 14.2704 2.85259 14.8288L0.850773 16.826C0.759017 16.921 0.632693 16.975 0.500455 16.9757C0.224061 16.9757 0 16.7522 0 16.4765V3.99429C0 1.78831 1.79249 0 4.00364 0H14.0127C16.2239 0 18.0164 1.78831 18.0164 3.99429V9.98573ZM20.0182 11.9829V3.99429C21.1159 4.00525 22.0001 4.8962 22 5.99144V20.5007C22 20.7765 21.7759 21 21.4995 21C21.3673 20.9992 21.241 20.9452 21.1492 20.8502L19.1474 18.8531C18.5824 18.2886 17.815 17.9724 17.0155 17.9743H6.00546C4.89989 17.9743 4.00364 17.0802 4.00364 15.9772H16.0146C18.2257 15.9772 20.0182 14.1889 20.0182 11.9829Z"
  />
)

export default ConversationBubbleDouble
